if (!customElements.get('advent-video-gallery')) {
  customElements.define(
    'advent-video-gallery',
    class AdventVideoGallery extends HTMLElement {
      connectedCallback() {
        this.videos = [...this.querySelectorAll('video')];

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.isVisible = entry.isIntersecting;
            this.updatePlayback();
          },
          { threshold: 0.1 }
        );

        this.handleVisibilityChange = () => this.updatePlayback();
        this.observer.observe(this);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      }

      updatePlayback() {
        const shouldPlay = this.isVisible && document.visibilityState === 'visible';

        this.videos.forEach((video) => {
          video.muted = true;

          if (shouldPlay) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }
    }
  );
}
